import React, { useState, useEffect } from "react";
import { Skeleton } from "@mui/material";
import { useSelector, RootStateOrAny } from "react-redux";
import { OportunidadesDataInterface } from "interfaces/oportunidades.interface";
import { useOportunidadesLead } from "services/api";

import OportunidadesItem from "screens/lead/components/cardOportunidades/components/OportunidadeItem";
import * as Styles from "screens/lead/components/cardOportunidades/styles";
import EspelhoVendasModal from "components/dialogCommon/templates/EspelhoVendasModal";
import ModalFulscreen from "components/ModalFullscreen";
import InputGrid from "screens/leads/components/InputGrid";
import useIsGerenteOrSuperintendente from "../../../../../hooks/useIsGerenteOrSuperintendente";
import { AuthState } from "../../../../../store/ducks/auth/types";
import { useVincularSimulacao } from "../../../../../services/api/AppWeb_Oportunidade/vincular-simulacao";
import * as IconSVG from "../../../../../assets/iconsSVG";
import NewOportunityForm from "../../../../../components/dialogCommon/templates/newOportunityForm";
import DialogCommon from "../../../../../components/dialogCommon";
import CustomPagination from "../../../../../components/CustomPagination";

interface Props {
  isOpen: boolean;
  idLead: string | undefined;
  accordionOpen: boolean;
  onChange: (val: boolean) => void;
  dataLead: any;
  readOnly?: boolean;
}

interface DocumentosProps {
  base64: string | null;
  titulo: string | null;
  tipoArquivo: string | null;
}
interface BodyProps {
  idLead365: string | null;
  documentos: DocumentosProps[] | any;
}
interface UploadProps {
  numeroFicha: string | null;
  body: BodyProps;
}

export function CardOportunidades(props: Props) {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const isGerenteSuperintendente = useIsGerenteOrSuperintendente();
  const { codigoEmpresaVendas365 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const ITEMS_PER_PAGE = 2;
  const [uploadBody, setUploadBody] = useState<UploadProps | null>(null);
  const [oportunityModal, setOportunityModal] = useState<boolean>(false);
  const [oportunidadesBool, setOportunidadesBool] = useState<boolean>(false);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [palavraChave, setPalavraChave] = useState<string>("");
  const { data, refetch, status, isFetching } = useOportunidadesLead({
    queryKey: `oportunidades-lead-detail${page}`,
    IdLead365: props.idLead || "",
    PaginaAtual: page,
    TotalItensRetorno: ITEMS_PER_PAGE,
    PalavraChave: palavraChave,
  });
  const [espelhoVendasModal, setEspelhoVendasModal] = useState(false);
  const [espelhoData, setEspelhoData] = useState<any>(null);

  const currentPage = data?.pagination.currentPage || 0;

  useEffect(() => {
    if (data?.pagination.quantityPages) {
      setTotalPages(data.pagination.quantityPages);
    }
  }, [data?.pagination.quantityPages]);

  const { mutate } = useVincularSimulacao({
    idLead365: uploadBody?.body?.idLead365,
    numeroFicha: uploadBody?.numeroFicha,
    documentos: uploadBody?.body?.documentos,
  }) as any;

  React.useEffect(() => {
    if (props.accordionOpen) {
      refetch();
    }
  }, [props.accordionOpen]);

  React.useEffect(() => {
    if (uploadBody !== null) {
      mutate();
      setUploadBody(null);
      refetch();
    }
  }, [uploadBody]);

  const handlePageChange = async (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => {
    await setPage(newPage);
    refetch();
  };

  const handleSearch = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      await setPage(1);
      refetch();
    }
  };

  const handleBtnSearch = async () => {
    await setPage(1);
    refetch();
  };

  return (
    <>
      <Styles.Container>
        {status === "error" ? (
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              fontFamily: "Inter",
              color: "#686775",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            Algo deu errado, tente novamente...
          </p>
        ) : null}

        <>
          <Styles.BodyTable>
            <InputGrid
              style={{ width: "500px", marginBottom: 20 }}
              variant="outlined"
              value={palavraChave}
              onChange={(e) => setPalavraChave(e.target.value)}
              onKeyDown={handleSearch}
              handleBtnSearch={handleBtnSearch}
            />
            <Styles.HeaderTable>
              <div className="col col-1">
                <p>Empreendimento</p>
              </div>
              <div className="col col-2">
                <p>ID Proposta</p>
              </div>
              <div className="col col-3">
                <p>Ficha n°</p>
              </div>
              <div className="col col-4">
                <p>Etapa</p>
              </div>
              <div className="col col-5" />
            </Styles.HeaderTable>
            {!isFetching ? (
              <Styles.ItemsList>
                {data?.data?.length === 0 ? (
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontFamily: "Inter",
                      color: "#686775",
                      fontWeight: "bold",
                      fontSize: 14,
                      marginBottom: 20,
                    }}
                  >
                    Nenhum registro encontrado
                  </p>
                ) : null}
                {data?.data?.map((item: OportunidadesDataInterface) => (
                  <OportunidadesItem key={item.idProposta} data={item} />
                ))}
              </Styles.ItemsList>
            ) : (
              <Skeleton variant="rounded" width={"100%"} height={200} />
            )}
          </Styles.BodyTable>
          <Styles.SpaceY space={20} />
          <CustomPagination
            count={totalPages}
            page={currentPage}
            onPageChange={handlePageChange}
          />
          <Styles.SpaceY space={40} />
          {(props?.dataLead?.proprio || isGerenteSuperintendente) &&
          !props.readOnly ? (
            <Styles.GradientButton onClick={() => setOportunityModal(true)}>
              NOVA PROPOSTA
            </Styles.GradientButton>
          ) : null}
        </>
      </Styles.Container>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setConfirmModal}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        icon={<IconSVG.OportunityIcon />}
        isFilter={false}
        titleHeader="Nova Proposta"
        title="Crie uma nova proposta"
        isClose
        width={600}
        marginBottom={54}
        component={
          // codigoEmpresaVendas365 === "4" ? (
          //   <NewOportunityVivazForm
          //     idLead={props?.idLead}
          //     idCorretor={data?.data?.idLeadCorretor}
          //     closeModal={() => setOportunityModal(false)}
          //     closeOportunidades={() => setOportunidadesBool(false)}
          //   />
          // ) : (
          <NewOportunityForm
            idLead={props?.idLead}
            idCorretor={data?.data?.idLeadCorretor}
            closeModal={() => setOportunityModal(false)}
            closeOportunidades={() => setOportunidadesBool(false)}
            refetch={() => refetch()}
            openSalesMirror={(val: any) => {
              setEspelhoData(val);
              setOportunityModal(false);
              setEspelhoVendasModal(true);
            }}
          />
          // )
        }
        setOpenModal={setOportunityModal}
        open={oportunityModal}
      />
      <ModalFulscreen
        open={espelhoVendasModal}
        setOpenModal={() => setEspelhoVendasModal(true)}
        onClose={() => setEspelhoVendasModal(false)}
      >
        <EspelhoVendasModal
          data={espelhoData}
          onClose={() => setEspelhoVendasModal(false)}
          idLead={props?.idLead}
          openOpportunityForm={() => setOportunityModal(true)}
        />
      </ModalFulscreen>
    </>
  );
}
